module.exports = __webpack_public_path__ + "static/media/right-arrow_color.ae90372e.svg";